<template>
  <v-container fluid tag="section">
      <base-material-dialog
        title='专利授权公告'
        :dialog="item.show"
        v-bind="$attrs"
        @on-dialog-change='dialogChange'
        max-width='450'
        persistent
      >
        <template v-slot:content>
          <v-card class="px-5" elevation="0">
            <v-form ref="form" lazy-validation>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-menu
                      v-model="dataSelect"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                      hide-details="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          outlined
                          v-model="form.certTimeStr"
                          label="授权公告日期"
                          :rules="required"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          hide-details='auto'
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        hide-details='auto'
                        locale="zh-cn"
                        v-model="form.certTimeStr"
                        @input="dataSelect = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <file-upload
                      label="证书上传(命名：专利号_电子版证书.pdf)"
                      :rules="required"
                      outlined
                      prepend-icon=''
                      accept=".pdf"
                      :bucket='bucket'
                      @on-file='onFileName'
                      :lazy='false'
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text class="text--disabled" @click='item.show = false'>
                关闭
              </v-btn>
              <v-btn color="primary" :loading="loading" @click='save'>
                保存
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
    </base-material-dialog>
    <v-snackbar v-model="tip.show" timeout='3000' centered rounded="pill" color="warning"><v-icon>mdi-alert-circle-outline</v-icon>&nbsp;
      <span class="font-weight-bold">{{ tip.text }}</span>
      <template v-slot:action="{ attrs }">
        <v-btn text fab v-bind="attrs" small @click="tip.show = false"><v-icon>mdi-close</v-icon></v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import { save } from '@/api/patent/index.js'
  import { ResetObject } from '@/utils/stringUtil.js'
  import FileUpload from '@/components/oss/Index.vue'

  export default {
    name: 'PatentCert',
    components: {
      FileUpload
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        dataSelect: false,
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        tip: { show: false, text: '' },
        bucket: 'yd-patent',
        form: {
          id: '',
          status: '',
          certTimeStr: '',
          certFileName: ''
        }
      }
    },
    methods: {
      save () {
        this.form.certTime = new Date(this.form.certTimeStr).getTime() / 1000
        if (this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      onFileName (fileName) {
        this.form.certFileName = `${this.bucket}/${fileName}`
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          this.form = JSON.parse(JSON.stringify(this.item.data))
          this.form.status = 35
        } else {
          ResetObject(this.form)
        }
      }
    }
  }
</script>

<style lang="sass">
  #system-user-detail-page
</style>
